module.exports = __webpack_public_path__ + "img/video.b98511bc.jpg";